import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
// import { initIOSKeyboardHandler } from "./utils/iosKeyboard";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // 네트워크 오류 시 자동 재시도 비활성화
      refetchOnWindowFocus: false, // 윈도우 포커스 시 자동 새로고침 비활성화
    },
  },
});
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// iOS 키보드 핸들러 초기화
// initIOSKeyboardHandler();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
);
